import { render, staticRenderFns } from "./totalOrders.vue?vue&type=template&id=d5f0cb00&scoped=true"
import script from "./totalOrders.vue?vue&type=script&lang=js"
export * from "./totalOrders.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./totalOrders.vue?vue&type=style&index=1&id=d5f0cb00&prod&scoped=true&lang=css"
import style2 from "./totalOrders.vue?vue&type=style&index=2&id=d5f0cb00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f0cb00",
  null
  
)

export default component.exports